var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bo-mission-import-main"}},[_c('bo-import',{attrs:{"title":"Import de nouveaux utilisateurs","subtitle":"Programme National","columns":_vm.columns,"defaultRoles":['user','ghost'],"routePrefix":"spiadi","storePrefix":"user"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }